import React from "react";
import { Zap } from "lucide-react";
import type { SlashCommand } from "../types";

interface SlashCommandMenuProps {
  commands: SlashCommand[];
  filter: string;
  onSelect: (command: SlashCommand) => void;
}

export function SlashCommandMenu({
  commands,
  filter,
  onSelect,
}: SlashCommandMenuProps) {
  const filtered = commands.filter(
    (cmd) =>
      cmd.name.toLowerCase().includes(filter.toLowerCase()) ||
      cmd.description.toLowerCase().includes(filter.toLowerCase())
  );

  if (filtered.length === 0) return null;

  return (
    <div className="cai-glass rounded-2xl shadow-[0_-4px_24px_rgba(0,0,0,0.3)] mx-3 mb-1.5 overflow-hidden shrink-0 relative z-[1]">
      <div className="px-3.5 pt-2.5 pb-1.5 text-[9px] text-text-secondary font-semibold uppercase tracking-wider">
        Quick Actions
      </div>
      <div className="px-1.5 pb-1.5 max-h-64 overflow-y-auto cai-scrollbar">
        {filtered.map((cmd) => (
          <button
            key={cmd.name}
            onClick={() => onSelect(cmd)}
            className="w-full flex items-center gap-2.5 px-2.5 py-2.5 rounded-xl hover:bg-accent-violet/8 transition-colors text-left"
          >
            <div className="w-7 h-7 bg-accent-violet/15 rounded-lg flex items-center justify-center shrink-0">
              {cmd.icon ? (
                <span className="text-sm">{cmd.icon}</span>
              ) : (
                <Zap size={13} className="text-accent-violet" />
              )}
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-text-primary text-[11px] leading-tight">
                {cmd.name}
              </div>
              <div className="text-[10px] text-text-secondary leading-tight mt-0.5 truncate">
                {cmd.description}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
